/**
 * #context_type.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
export var ContextType;
(function (ContextType) {
    ContextType[ContextType["POST"] = 0] = "POST";
    ContextType[ContextType["COMMENT"] = 1] = "COMMENT";
    ContextType[ContextType["SUBREDDIT"] = 2] = "SUBREDDIT";
    ContextType[ContextType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ContextType || (ContextType = {}));
export function contextTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "POST":
            return ContextType.POST;
        case 1:
        case "COMMENT":
            return ContextType.COMMENT;
        case 2:
        case "SUBREDDIT":
            return ContextType.SUBREDDIT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ContextType.UNRECOGNIZED;
    }
}
export function contextTypeToJSON(object) {
    switch (object) {
        case ContextType.POST:
            return 0;
        case ContextType.COMMENT:
            return 1;
        case ContextType.SUBREDDIT:
            return 2;
        case ContextType.UNRECOGNIZED:
        default:
            return -1;
    }
}
